export const MIN_DAYS_DEFERRED_SHIPMENT = 14;

export const PAGE_SIZES = [50, 100, 200];
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];
